import { render, staticRenderFns } from "./MyRegister.vue?vue&type=template&id=59c21d8a&scoped=true&"
import script from "./MyRegister.vue?vue&type=script&lang=js&"
export * from "./MyRegister.vue?vue&type=script&lang=js&"
import style0 from "./MyRegister.vue?vue&type=style&index=0&id=59c21d8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c21d8a",
  null
  
)

export default component.exports